export function formatNumber(value: unknown) {
  if (typeof value === 'string' || typeof value === 'number') {
    return Number.isNaN(Number(value)) ? undefined : Number(value);
  }

  return undefined;
}
